import React from 'react';
import { PortableTextBlock } from '@portabletext/react';
import { InformationSummary } from '@naf-simba/sections-information-summary';
import BlockContent from '../../../components/block-content/BlockContent';

interface InfoBoxProps {
  displayOption: 'standard' | 'green';
  title?: string;
  text: PortableTextBlock[];
}

const ProductTestInfoBox = ({ title, text, displayOption }: InfoBoxProps) => (
  <InformationSummary
    variant="infobox"
    displayOption={displayOption}
    title={title}
    content={<BlockContent value={text} />}
  />
);

export { ProductTestInfoBox };
